import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {InteractiveTable} from 'main/components';
import {Tag} from 'shared/components';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {NmbrTaxDocument} from 'main/stores/nmbr';

const ViewFileButton = observer(({model}) => {
  return (
    <a
      className='TextLink dodger'
      href={`/api/v1${endpoints.NMBR.TAX_DOCUMENT.with(model.id)}`}
      target='_blank' rel='noreferrer'
    >
      <FormattedMessage id='employees.profile.banking.View File'/>
    </a>
  );
});

const FormName = observer(({model}) => {
  return (
    <div className='flex align-items-middle'>
      <div>{model.name}</div>
      {model.stage === 'amendment' && <Tag colour='meadow' className='ml1'>
        <FormattedMessage id='employees.profile.banking.Amendment'/>
      </Tag>}
    </div>
  );
});

const COLUMNS = [
  {
    header: 'employees.profile.banking.Document Type',
    width: 4,
    component: FormName
  },
  {
    header: 'employees.profile.banking.Tax Year',
    width: 3,
    attribute: 'taxYear'
  },
  {
    header: 'employees.profile.banking.Date Added',
    width: 3,
    attribute: 'createdAtView'
  },
  {
    width: 2,
    className: 'right-align',
    component: ViewFileButton
  }
];

const NmbrTaxDocumentsTable = observer(({employee}) => {
  return (
    <InteractiveTable
      title={t('employees.profile.banking.Tax Documents')}
      columns={COLUMNS}
      showLinks={false}
      searchable={false}
      sortable={false}
      proxy={{
        type: 'async',
        modelType: types.NMBR.TAX_DOCUMENT,
        model: NmbrTaxDocument,
        endpoint: endpoints.NMBR.TAX_DOCUMENTS.with(employee.id),
        pageSize: 15
      }}
    />
  );
});

export default NmbrTaxDocumentsTable;
